import React from 'react';
import { ImageIcon } from 'lucide-react';
import { previewSlots } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function LookInside() {
  return <section className="bg-paper py-20 lg:py-28" data-id="element-111" data-mp="21naqghc22x3u">
      <div className="mx-auto max-w-content px-5 sm:px-8" data-id="element-112" data-mp="21mhft59z7ngf">
        <SectionHeading title="Look Inside The Worry-to-Brave Toolkit" intro={<>
              <p className="font-medium text-ink" data-id="element-114" data-mp="1rw6apfek387y">This isn’t just information to read.</p>
              <p className="mt-2" data-id="element-115" data-mp="1wo7j2q8lsesp">
                The toolkit was designed to give you practical resources you can return to when real-life worry shows up.
              </p>
            </>} data-id="element-113" data-mp="25o2zb9h0mzzl" />

        <ul className="mt-14 grid grid-cols-2 gap-4 lg:grid-cols-3 lg:gap-5" data-id="element-116" data-mp="1mz63v29vu1fs">
          {previewSlots.map((slot, i) => {
          const featured = i === 0;
          const last = i === previewSlots.length - 1;
          const layout = featured ? 'col-span-2 aspect-[4/3] lg:row-span-2 lg:aspect-auto' : last ? 'col-span-2 aspect-[16/9] lg:col-span-1 lg:aspect-[4/3]' : 'aspect-[3/4] lg:aspect-[4/3]';
          return <li key={slot.label} className={`relative overflow-hidden rounded-2xl bg-cream-deep ${layout}`} data-id="element-117" data-mp="k13xx0affmtj" data-mpi={i}>
                {slot.src ? <img src={slot.src} alt={`Inside the toolkit: ${slot.label}`} className="h-full w-full object-cover" data-id="element-118" data-mp="ezoa50gv727g" /> : <div className="absolute inset-3 flex flex-col items-center justify-center rounded-xl border border-dashed border-ink/20 text-center" data-id="element-119" data-mp="3iizo8m3c8rfc">
                    <span className="flex h-11 w-11 items-center justify-center rounded-full bg-paper text-ink-mute" data-id="element-120" data-mp="142pf5hnz4ku">
                      <ImageIcon className="h-5 w-5" aria-hidden="true" data-id="element-121" data-mp="34r31kxkfv9qc" />
                    </span>
                    <span className={`mt-3 font-display text-ink ${featured ? 'text-[28px]' : 'text-[20px]'}`} data-id="element-122" data-mp="2zrzw5c0jr1hu">{slot.label}</span>
                  </div>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}